import type { InitialState } from './reducer';

export const init = (initialState: InitialState) => {
  return initialState;
};
